import gql from "graphql-tag";

export const CREATE_CRM_SENDING_SCHEDULE = gql`
  mutation AddCrmSendingSchedule($data: CrmSendingScheduleDataInput) {
    addCrmSendingSchedule(data: $data) { id name }
  }
`;

export const UPDATE_CRM_SENDING_SCHEDULE = gql`
  mutation UpdateCrmSendingSchedule($where: CrmSendingScheduleWhereInput, $data: CrmSendingScheduleDataInput) {
    updateCrmSendingSchedule(where: $where, data: $data) { id }
  }
`;

const crmSchedules = { CREATE_CRM_SENDING_SCHEDULE, UPDATE_CRM_SENDING_SCHEDULE };
export default crmSchedules;
